var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      on: {
        mouseenter: function($event) {
          _vm.hovering = true
        },
        mouseleave: function($event) {
          _vm.hovering = false
        }
      }
    },
    [
      !_vm.readOnly
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.amount,
                expression: "amount"
              }
            ],
            ref: "numeric",
            staticClass: "van-field__control--right",
            staticStyle: { border: "none" },
            attrs: {
              placeholder: _vm.placeholder,
              type: "tel",
              readonly: _vm.readOnlyInput
            },
            domProps: { value: _vm.amount },
            on: {
              blur: _vm.onBlurHandler,
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.amount = $event.target.value
                },
                _vm.onInputHandler
              ],
              focus: _vm.onFocusHandler,
              change: _vm.onChangeHandler
            }
          })
        : _c("span", { ref: "readOnly" }, [_vm._v(_vm._s(_vm.amount))]),
      _vm.showClear
        ? _c("i", {
            staticClass: "van-icon van-icon-clear van-field__clear",
            on: { click: _vm.clear }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }